import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

export const useSharedState = () => useContext(StateContext);

export const StateProvider = ({ children }) => {
  const [value, setValue] = useState({
    title: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    addressLineOne: "",
    addressLineTwo: "",
    city: "",
    postcode: "",
    password: "",
    confirmedPassword: "",
    email: "",
    addressId: "",
    childFirstName: "",
    childLastName: "",
    DOB: "",
    gender: "",
    childUsername: "",
    childPassword: "",
    childConfirmedPassword: "",
    school: "",
    verificationCode: "",
  });

  const [loading, setLoading] = useState(false);

  const [grammarSchools, setGrammarSchools] = useState([]);

  const [schoolList, setSchoolList] = useState([]);

  const [verified, setVerified] = useState(false);

  const [loginToken, setLoginToken] = useState("");

  const [studentId, setStudentId] = useState("");

  const [mentorId, setMentorId] = useState("");

  const [mentorEmail, setMentorEmail] = useState("");

  const [testData, setTestData] = useState([]);

  const [testQuestions, setTestQuestions] = useState([]);

  const [liveCurrentQuizQuestions, setLiveCurrentQuizQuestions] = useState([]);

  const [singleQuizQuestion, setSingleQuizQuestion] = useState([]);

  const [questionId, setQuestionId] = useState(undefined);

  const [quizSummaryId, setQuizSummaryId] = useState(0);

  const [curriculumId, setCurriculumId] = useState(0);

  const [testAnswers, setTestAnswers] = useState([]);

  const [addressData, setAddressData] = useState({});

  const [totalQuestions, setTotalQuestions] = useState(0);

  const [index, setIndex] = useState(0);

  const [summary, setSummary] = useState([]);

  const [backKey, setBackKey] = useState(false);

  const [backKeyDashboard, setBackKeyDashboard] = useState(false);

  const [isValidYear, setIsValidYear] = useState(false);

  const [urlPrefix, setUrlPrefix] = useState("");

  const [isGcse, setIsGcse] = useState(false);

  const [captcha, setCaptcha] = useState(false);

  // Prefix comes directly from .env file (REACT_APP_BASE_URL)
  // No modifications or normalization - use exactly as specified in .env
  const prefix = process.env.REACT_APP_BASE_URL || "https://ksol.co.uk";
  
  // Validate that REACT_APP_BASE_URL is set in .env file
  if (!process.env.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL.trim() === "") {
  }

  return (
    <StateContext.Provider
      value={{
        value,
        setValue,
        addressData,
        setAddressData,
        loginToken,
        setLoginToken,
        loading,
        setLoading,
        studentId,
        setStudentId,
        testData,
        setTestData,
        testQuestions,
        setTestQuestions,
        testAnswers,
        setTestAnswers,
        questionId,
        setQuestionId,
        quizSummaryId,
        setQuizSummaryId,
        curriculumId,
        setCurriculumId,
        singleQuizQuestion,
        setSingleQuizQuestion,
        index,
        setIndex,
        totalQuestions,
        setTotalQuestions,
        summary,
        setSummary,
        verified,
        setVerified,
        backKey,
        setBackKey,
        backKeyDashboard,
        setBackKeyDashboard,
        grammarSchools,
        setGrammarSchools,
        schoolList,
        setSchoolList,
        isValidYear,
        setIsValidYear,
        urlPrefix,
        setUrlPrefix,
        prefix,
        mentorId,
        setMentorId,
        mentorEmail,
        setMentorEmail,
        liveCurrentQuizQuestions,
        setLiveCurrentQuizQuestions,
        isGcse,
        setIsGcse,
        captcha,
        setCaptcha,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};
